/*
  Create by BaiZhiming 2016-3-8
*/
'use strict';
var ueditor_closeMas; //跨域通知；
angular.module("util.ueditorServiceModule", ["basicUploadPicturesModule", "insertVideoModule", "insertAudioModule", "insertwordModule"])
    .factory("ueditorService", ["$modal", "$q", "httpService", "localStorageService", "$timeout",
        function ($modal, $q, httpService, localStorageService, $timeout) {
            function replaceHtmlBlank(htmlContent) {
                htmlContent = htmlContent.replace(/(<[^>]+>)([^<>]+)(<[^>]+>)/g, function ($0, $1, $2, $3) {
                    var innerContent = $2.replace(/ /g, "\u3000");
                    return $1 + innerContent + $3;
                });
                return htmlContent;
            }
            /**
             * [sourceModeSwitch description]源码模式下转换html正文
             * @param {string} [htmlcontent] [description] html正文
             * @return {string} htmlcontent  [description] 转换后的html正文
             */
            function sourceModeSwitch(ue, contentHtml) {
                var ueDom = UE.dom;
                if (ue.sourceMode) { //兼容源码模式下的保存正文,解决保存正文后出现多余空格的问题。
                    contentHtml = contentHtml.replace(new RegExp('[\\r\\t\\n ]*<\/?(\\w+)\\s*(?:[^>]*)>', 'g'), function (a, b) {
                        if (b && !ueDom.dtd.$inlineWithA[b.toLowerCase()]) {
                            return a.replace(/(^[\n\r\t ]*)|([\n\r\t ]*$)/g, '');
                        }
                        return a.replace(/(^[\n\r\t]*)|([\n\r\t]*$)/g, '');
                    });
                    ue.orgSetContent(contentHtml);
                    return ue.oldGetContent();
                } else {
                    return contentHtml;
                }
            }
            return {
                saveContent: function (list) {
                    var ue = UE.getEditor('ueditor');
                    var contentHtml = ue.getContent(),
                        hasImage = false,
                        hasIframe = false,
                        contentHtml = sourceModeSwitch(ue, contentHtml); //自动检测转换html模式下的正文
                    var contentTxt = (function () {
                        var dom = document.createElement("div");
                        dom.innerHTML = contentHtml;
                        hasImage = $(dom).find("img").length > 0 ? true : false;
                        hasIframe = $(dom).find("iframe").length > 0 ? true : false;
                        return dom.innerText;
                    })();
                    if (contentTxt !== '' && contentTxt.replace(/\u3000/g, "").replace(/\u0020/g, "").replace(/\n/g, "") === "" && !(hasImage || hasIframe)) {
                        list.articleHtmlCon = "";
                        list.articleContent = "";
                        list.DOCWORDSCOUNT = 0;
                    } else {
                        list.articleHtmlCon = contentHtml;
                        list.articleHtmlCon = list.articleHtmlCon.replace(/<hr ispageseparator=\"true\"\/>/g, '<trs_page_separator pagetitle="" firstpagetitle=""></trs_page_separator>'); //替换分页符置标
                        var content = list.articleHtmlCon.replace(/\n/g, "");
                        var dom = document.createElement("div");
                        dom.innerHTML = content;
                        var htmlContent = dom.innerHTML.replace(/<\/p>/g, '\n')
                            .replace(/<\/div>/g, '\n')
                            .replace(/<(p|div)[^>]*>/ig, '')
                            .replace(/<br\/?>/gi, '\n')
                            .replace(/<[^>]+>/g, '')
                            .replace(/&nbsp;/g, '\u3000');
                        if (htmlContent[htmlContent.length - 1] === "\n") { //去掉文章末尾的换行
                            htmlContent = htmlContent.substring(0, htmlContent.length - 1);
                        }
                        content = htmlContent.replace(/\u00a0/g, ' ');
                        /*
                        content = content.replace(/\n/g, "").replace(/<\/(div|p|h\d)>/ig, "\n")
                            .replace(/<br[^>]*>/ig, "\n").replace(/<[^>]+>/g, "")
                            .replace(/&nbsp;/g, "");
                            */
                        list.articleContent = content;
                        list.DOCWORDSCOUNT = content.replace(/\n/g, "").replace(/\u0020/g, "").replace(/\u3000/g, "").length;
                    }
                },
                bindContent: function () {
                    var ue = UE.getEditor('ueditor');
                    var HTMLCONTENT = ue.getContent();
                    HTMLCONTENT = sourceModeSwitch(ue, HTMLCONTENT); //自动检测转换html模式下的正文
                    var content = HTMLCONTENT.replace(/\n/g, "");
                    var dom = document.createElement("div");
                    dom.innerHTML = content;
                    content = dom.innerText.replace(/\u00a0/g, ' ').replace(/<!--((.*)|(\n))*?-->/g, "");
                    return content;
                },
                /**
                 * [bindContentForKeyword description] 提取关键词跟摘要使用换行的正文
                 * @return {[type]} [description]
                 */
                bindContentForKeyword: function () {
                    var ue = UE.getEditor('ueditor');
                    var HTMLCONTENT = ue.getContent();
                    HTMLCONTENT = sourceModeSwitch(ue, HTMLCONTENT); //自动检测转换html模式下的正文
                    var dom = document.createElement("div");
                    dom.innerHTML = HTMLCONTENT;
                    var htmlContent = dom.innerHTML.replace(/<\/p>/g, '\n')
                        .replace(/<\/div>/g, '\n')
                        .replace(/<(p|div)[^>]*>/ig, '')
                        .replace(/<br\/?>/gi, '\n')
                        .replace(/<[^>]+>/g, '')
                        .replace(/&nbsp;/g, '\u3000');
                    if (htmlContent[htmlContent.length - 1] === "\n") { //去掉文章末尾的换行
                        htmlContent = htmlContent.substring(0, htmlContent.length - 1);
                    }
                    var content = htmlContent.replace(/\u00a0/g, ' ').replace(/<!--((.*)|(\n))*?-->/g, "");
                    return content;
                },
                contentTranscoding: function (list) {
                    var htmlcontent = list.articleHtmlCon;
                    var content = htmlcontent.replace(/\n/g, "");
                    var dom = document.createElement("div");
                    dom.innerHTML = content;
                    content = dom.innerText.replace(/\u00a0/g, ' ').replace(/<!--((.*)|(\n))*?-->/g, "");
                    /*
                    content = content.replace(/\n/g, "").replace(/<\/(div|p|h\d)>/ig, "\n")
                        .replace(/<br[^>]*>/ig, "\n").replace(/<[^>]+>/g, "")
                        .replace(/&nbsp;/g, "");
                        */
                    return content;
                },
                /**
                 * [sourceModeSwitch description]源码模式下转换html正文
                 * @param {string} [htmlcontent] [description] html正文
                 * @return {string} htmlcontent  [description] 转换后的html正文
                 */
                sourceModeSwitch: function (ue, contentHtml) {
                    return sourceModeSwitch(ue, contentHtml);
                },
                replaceHtmlBlank: function (htmlContent, versionid) {
                    return replaceHtmlBlank(htmlContent);
                },
                saveToLocal: function (docId, versionid, doctype) {
                    versionid = angular.isDefined(versionid) && versionid !== "" ? versionid : '0';
                    var ue = UE.getEditor('ueditor');
                    var content = ue.getContent();
                    if (content !== "") {
                        var storage = localStorageService.get("ueLocalVersion");
                        if (storage !== null) {
                            var flag = true;
                            for (var i = 0; i < storage.length; i++) {
                                if (storage[i].ID === (docId + "")) {
                                    storage[i].CONTENT = content;
                                    storage[i].VERSIONID = versionid;
                                    storage[i].DOCTYPE = doctype || '0';
                                    flag = false;
                                    break;
                                }
                            }
                            if (flag) {
                                storage.unshift({
                                    ID: (docId + ""),
                                    CONTENT: content,
                                    VERSIONID: versionid,
                                    DOCTYPE: doctype || '0'
                                });
                                if (storage.length > 10) {
                                    storage.length = 10;
                                }
                            }
                            /*ue.trigger('showmessage', {
                                content: ue.getLang('autosave.saving'),
                                timeout: 2000
                            });*/
                            localStorageService.set("ueLocalVersion", storage);
                        } else {
                            var ueLocalVersion = [];
                            var version = {};
                            version.ID = (docId + "");
                            version.CONTENT = content;
                            version.VERSIONID = versionid;
                            version.DOCTYPE = doctype || '0';
                            ueLocalVersion.push(version);
                            /*ue.trigger('showmessage', {
                                content: ue.getLang('autosave.saving'),
                                timeout: 2000
                            });*/
                            localStorageService.set("ueLocalVersion", ueLocalVersion);
                        }
                        /*setTimeout(function() {
                            ue.trigger('showmessage', {
                                content: ue.getLang('autosave.success'),
                                timeout: 2000
                            });
                        }, 2000);*/
                    }
                },
                /**
                 * [handlingSensitiveInf description]处理敏感信息
                 * @param  {[type]} SensitiveWordresults [description]敏感词结果
                 * @param  {[type]} htmlcontent [description]html正文
                 * @return {[type]}      [description]
                 */
                handlingSensitiveInf: function (SensitiveWordresults, htmlcontent) {
                    var resultInfo = SensitiveWordresults.content[0].resultInfo;
                    for (var i = 0; i < resultInfo.length; i++) {
                        htmlcontent = htmlcontent.replace(new RegExp(resultInfo[i].errorWord, "g"), "<span style='background-color:#F89F9F' title='" + resultInfo[i].errorInfo + "'>" + resultInfo[i].errorWord + "</span>");
                    }
                    return htmlcontent;
                },
                /**
                 * [removeToolBarFunction description]剔除编辑器工具栏按键的功能
                 * @param  {[type]}  toolBar [description] 工具条对象
                 * @param  {[array]} indexArray [description]功能键序号
                 * @return {[type]}      [description]
                 */
                removeToolBarFunction: function (toolBar, indexArray) {
                    indexArray.sort(function (a, b) {
                        return b - a;
                    });
                    for (var i = 0; i < indexArray.length; i++) {
                        var index = indexArray[i];
                        toolBar.splice(index, 1);
                    }
                    /*var i = indexArray.length - 1;
                    while (i >= 0) {
                        var index = indexArray[i];
                        toolBar.splice(index, 1);
                        i--;
                    }*/
                    return toolBar;
                },
                /**
                 * [getToolBar description]获取编辑器的工具条
                 * @return {[obj]}   toolBar   [description]
                 */
                getToolBar: function () {
                    return {
                        toolbars: [
                            [
                                'source' /*0*/,
                                'undo' /*1*/,
                                'redo' /*2*/,
                                '|' /*3*/,
                                'cut' /*4*/,
                                'copy' /*5*/,
                                'paste' /*6*/,
                                '|' /*7*/,
                                'customstyle' /*8*/,
                                'fontfamily' /*9*/,
                                'fontsize' /*10*/,
                                'forecolor' /*11*/,
                                'bold' /*12*/,
                                'italic' /*13*/,
                                'underline' /*14*/,
                                'strikethrough' /*15*/,
                                'subscript' /*16*/,
                                'backcolor' /*17*/,
                                '|' /*18*/,
                                'justifyleft' /*19*/,
                                'justifycenter' /*20*/,
                                'justifyright' /*21*/,
                                'justifyjustify' /*22*/,
                                '|' /*23*/,
                                'insertorderedlist' /*24*/,
                                'insertunorderedlist' /*25*/,
                                'directionalityltr' /*26*/,
                                'directionalityrtl' /*27*/,
                                'lineheight' /*28*/,
                                /* 'background', 'backgroundimg', */
                                '|' /*29*/,
                                'formatmatch' /*30*/,
                                'searchreplace' /*31*/,
                                'insertframe' /*32*/,
                                'insertimage' /*33*/,
                                // 'insertvideo' ,
                                'link' /*34*/,
                                'unlink' /*35*/,
                                'inserttable' /*36*/,
                                'insertrow' /*37*/,
                                'insertcol' /*38*/,
                                'inserttitle' /*39*/,
                                'insertparagraphbeforetable' /*40*/,
                                'fullscreen' /*41*/,
                                'removeformat' /*42*/,
                                'autotypeset' /*43*/,
                                'indent' /*44*/,
                                'pasteplain', /*45*/
                                // 'insertvideo', /*46*/
                                // 'insertword'
                            ]
                        ],
                        labelMap: {
                            'anchor': '',
                            'undo': '',
                            'cut': '剪切',
                            'copy': '复制',
                            'paste': '粘贴',
                            'backgroundimg': '背景图',
                            'allowCopyImg': true, //自定义百度编辑器配置项，禁止拷贝图片到编辑器
                        },
                        //如果自定义，最好给p标签如下的行高，要不输入中文时，会有跳动感
                        initialStyle: 'p{line-height:1.5em}', //编辑器层级的基数,可以用来改变字体等
                        maximumWords: 100000,
                        autoHeightEnabled: true,
                        topOffset: 61,
                        enableContextMenu: false,
                        allowDivTransToP: false,
                        imageScaleEnabled: false,
                        pasteplain: true
                        //pageBreakTag:'\<trs_page_separator pagetitle=\"\" firstpagetitle=\"\"\>\<\/trs_page_separator\>'
                    };
                },
                /**
                 * [basicUploadPic] 非APP渠道的多图上传
                 * @return {[type]} [description]
                 */
                basicUploadPic: function (imgInfo) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: "./utils/ueditor/service/template/basicUploadPictures_tpl.html",
                        windowClass: 'ueditor-pictures-window',
                        backdrop: false,
                        controller: "basicUploadPicturesCtrl",
                        resolve: {
                            imgInfo: function () {
                                return imgInfo;
                            }
                        }
                    });
                    modalInstance.result.then(function (result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },
                insertVideo: function (videoInfo) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: "./utils/ueditor/service/template/insertVideo_tpl.html?myvideoclose=" + window.location.href,
                        windowClass: 'insertVideo',
                        backdrop: false,
                        controller: "insertVideoCtrl",
                        resolve: {
                            videInfo: function () {
                                return videoInfo;
                            }
                        }
                    });
                    modalInstance.result.then(function (result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },
                insertAudio: function (audioInfo) {
                    // debugger;
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: "./utils/ueditor/service/template/insertAudio_tpl.html",
                        windowClass: 'insertAudio',
                        backdrop: false,
                        controller: "insertAudioCtrl",
                        resolve: {
                            audioInfo: function () {
                                return audioInfo;
                            }
                        }
                    });
                    modalInstance.result.then(function (result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },
                insertword: function (wordinfo) {
                    // debugger;
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: "./utils/ueditor/service/template/insertword_tpl.html",
                        windowClass: 'insertword',
                        backdrop: false,
                        controller: "insertwordCtrl",
                        resolve: {
                            wordinfo: function () {
                                return wordinfo;
                            }
                        }
                    });
                    modalInstance.result.then(function (result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },
                /**
                 * [cloudPlate description] 云平台组件
                 * @param  {[type]}    [description]
                 * @return {[type]}    [description]
                 */
                cloudPlate: function () {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: "./components/util/ueditor/service/template/cloudPlate_tpl.html",
                        windowClass: 'cloud-plate-window',
                        backdrop: false,
                        controller: "cloudPlateCtrl"
                    });
                    modalInstance.result.then(function (result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },
                /**
                 * [setPlaceholder description]
                 */
                setPlaceholder: function (ue, placeholder) {
                    if (!placeholder) return;
                    var placeholderContent = '<p class="placeholder">' + placeholder + '</p>';
                    var content = ue.getContent();
                    ue.placeholder = placeholderContent;
                    if (!content) {
                        ue.setContent(placeholderContent);
                    }
                    ue.addListener("mousedown", function () {
                        var content = ue.getContent(); //该方法拿到的正文已经过滤了placeholder，所以在插入失焦情况直接插入要做特殊处理
                        if (content === "") {
                            ue.setContent("");
                        }
                    });
                    ue.addListener("keydown", function () {
                        var content = ue.getContent(); //该方法拿到的正文已经过滤了placeholder，所以在插入失焦情况直接插入要做特殊处理
                        if (content === "") {
                            ue.setContent("");
                        }
                    });
                    ue.addListener("blur", function () {
                        var content = ue.getContent(); //该方法拿到的正文已经过滤了placeholder，所以在插入失焦情况直接插入要做特殊处理
                        if (content === "") {
                            ue.setContent(placeholderContent);
                        }
                    });
                    ue.addListener("beforeInserthtml", function () {
                        var content = ue.getContent(); //该方法拿到的正文已经过滤了placeholder，所以在插入失焦情况直接插入要做特殊处理
                        if (content === "") {
                            ue.setContent("");
                        }
                    });
                },
                /**
                * [isEditor description] 给音视频图片添加标识
                * @param   {[boolean]}  isEditor    [isEditor description] 是否是编辑器
                * @param   {[boolean]}  reDraw      [isEditPage description]  重新渲染
                * @return  {[undefined]}            [return description]
                */
                drawVideoMark: function (isEditor, reDraw) {
                    var videoImg;
                    $timeout(() => {
                        if (isEditor) {
                            var iframe = document.getElementById("ueditor_0");
                            var iwindow = iframe.contentWindow;
                            var idoc = iwindow.document;
                            videoImg = idoc.getElementsByClassName('trsresize')
                        }
                        else {
                            videoImg = $('img.trsresize');
                        }
                        if (!videoImg.length) { return; } // 没有视频图片就退出
                        var img = new Image();
                        // var mediaType = 'video';
                        //  将图片画到canvas上面上去！
                        img.setAttribute('crossOrigin', 'anonymous');
                        img.onload = function () {
                            for (let i = 0; i < videoImg.length; i++) {
                                if (reDraw) { // 切换编辑器时去掉属性，重新画一遍
                                    videoImg[i].removeAttribute('crossOrigin');
                                }
                                if (videoImg[i].getAttribute('crossOrigin') === 'anonymous') { // 插入编辑器时，考虑到有新增的，老的被打标的图片不再重新渲染
                                    continue;
                                }
                                let image = new Image();
                                image.setAttribute('crossOrigin', 'anonymous');
                                image.onload = function () {
                                    let video = videoImg[i];
                                    if (!video.getAttribute('videoid')) {
                                        return;
                                    } // 没有videoid就表示不是视频，并且不是视频就退出
                                    var canvas = document.createElement('canvas');
                                    //  获取2d对象
                                    var ctx = canvas.getContext('2d');
                                    canvas.width = video.width;
                                    //  视频无法渲染设定图片固定值
                                    canvas.height = video.height;
                                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                                    // 先截图当前的图
                                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                                    var base64 = canvas.toDataURL('image/png');
                                    video.src = base64;
                                    try {
                                        var imgWH = 88;
                                        // 再给截图填上视频标记戳
                                        ctx.drawImage(img, canvas.width / 2 - (imgWH / 2), canvas.height / 2 - (imgWH / 2), imgWH, imgWH);
                                        //  获取base64的图片数据
                                        base64 = canvas.toDataURL('image/png');
                                        video.src = base64;
                                    } catch { }
                                };
                                if (videoImg[i].src.includes('?')) {
                                    let srcArr = videoImg[i].src.split('?');
                                    image.src = srcArr[0] + '?time=' + new Date().valueOf() + '&' + srcArr[1] + '&';
                                } else {
                                    image.src = videoImg[i].src + '?time=' + new Date().valueOf();
                                }
                            }
                        };
                        img.src = './images/videoMark.png';
                    });
                },

                /**
                 * [transcodeVideo description] 转码中的视频是否转码完成，若转码完成替换封面图
                 *
                 * @param   {[type]}  list  [list description] 富文本字符串
                 *
                 * @return  {function}      [return description]
                 */
                transcodeVideo: function(htmlContent) {
                    var defer = $q.defer();
                    var domBox = document.createElement('div');
                    $(domBox).html(htmlContent);
                    var dom = $(domBox).find('img[src="./images/video_default.png"]');
                    var domArr = Array.prototype.slice.call(dom);
                    var videoIdArr = domArr.filter(function(item){
                        return !!($(item).attr('videoid'));
                    }).map(function(item) {
                        return $(item).attr('videoid');
                    });
                    if (videoIdArr.length) {
                        var params = {
                            docids: videoIdArr.join(';')
                        };
                        httpService.http('/transfer/aav/video/search?tenantId=3&userId=AAAABQAMdGVzdEB0cnMuY29tABx0ZXN0QHRycy5jb20sMywxNTc4ODg4Nzg1Nzk4AAAALzAtAhUAkYbTEsbpfqXrVG9_psU_CpwT5lkCFFw1Gq_Hk3yYL89R0fi3yw9f8koN', JSON.stringify(params), "post", '', '', {
                            'formdata': "1",
                            'Content-Type': 'application/json',
                            'requestToken':sessionStorage.getItem('requestToken')
                        }).then(function(data) {
                            for (var i = 0; i < data.datas.length; i++) {
                                var index = videoIdArr.indexOf(data.datas[i].videoid);
                                if (data.datas[i].img) {
                                    $(dom[index]).attr('src', data.datas[i].img);
                                }
                            }
                            defer.resolve($(domBox).html());
                        }, function() {
                            defer.resolve();
                        });
                    } else {
                        defer.resolve();
                    }
                    return defer.promise;
                }
            };
        }])
